import React, {Component} from 'react';
import {Typography, Paper} from "@material-ui/core";

class CanadaOverview extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    /* -------- LIFECYCLE METHODS -------- */


    /* -------- FUNCTIONS -------- */


    /* -------- API CALLS -------- */


    /* -------- RENDERS -------- */
    render() {
        let {data} = this.props;

        let confirmed = 0;
        let recovered = 0;
        let deaths = 0;

        data.forEach(p => {
            confirmed += p.confirmed;
            recovered += p.recovered;
            deaths += p.deaths;
        })

        return <div className='section'>
            <Typography variant={'h4'} align={'left'} style={{marginBottom: 8}}>Canada Situation *</Typography>
            <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', minHeight: 102}}>
                <Paper style={{flex: 1, padding: '8px 24px 8px', margin: '8px 12px', backgroundColor: '#e0f2f1'}}>
                    <Typography variant={'h5'} align={'left'}>Confirmed</Typography>
                    <Typography variant={'h3'} align={'left'}>{Number(confirmed).toLocaleString('en')}</Typography>
                </Paper>
                <Paper style={{flex: 1, padding: '8px 24px 8px', margin: '8px 12px', backgroundColor: '#c8e6c9'}}>
                    <Typography variant={'h5'} align={'left'}>Recovered</Typography>
                    <Typography variant={'h3'} align={'left'}>{Number(recovered).toLocaleString('en')}</Typography>
                </Paper>
                <Paper style={{flex: 1, padding: '8px 24px 8px', margin: '8px 12px', backgroundColor: '#ff8a80'}}>
                    <Typography variant={'h5'} align={'left'}>Deaths</Typography>
                    <Typography variant={'h3'} align={'left'}>{Number(deaths).toLocaleString('en')}</Typography>
                </Paper>
            </div>
            <div style={{width: '100%', display: 'flex', marginTop: '8px'}}>
                <Typography variant={'caption'} align={'left'}>* Excludes Repatriated Travellers</Typography>
            </div>
        </div>
    }
}

export default CanadaOverview